export const CHANGE_THEME = "CHANGE_THEME";
export const DARK = "DARK";
export const LIGHT = "LIGHT";
